import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { Role } from '../types/role.interface';

export const roleDefinition: EntityDefinition<Role> = {
  entityType: 'Role',
  i18nBase: 'entities.role',
  list: {
    columns: [],
  },
  fields: [{ field: 'name', labelKey: 'common.labels.name', required: true, type: 'text', minLength: 3, maxLength: 50 }],
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: Role) => !entity.isUsed,
      errorMessageKey: 'entities.role.messages.deleteError',
    },
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: Role, store) => {
        if (!store) return true;
        const entities = store.getData<Role>('Role')();
        return !entities.some(type => type.name.toLowerCase().trim() === entity.name.toLowerCase().trim());
      },
      errorMessageKey: 'entities.role.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: Role, store) => {
        if (!store) return true;
        const entities = store.getData<Role>('Role')();
        return !entities.some(type => type.name.toLowerCase().trim() === entity.name.toLowerCase().trim() && type.id !== entity.id);
      },
      errorMessageKey: 'entities.role.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.role.messages.createTitle',
      edit: () => 'entities.role.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.role.messages.addButton',
      create: () => 'entities.role.messages.addButton',
      edit: () => 'entities.role.messages.editTitleWithName',
      delete: () => 'entities.role.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.role.messages.deleteConfirm',
  },
  enableFiltering: true,
};
